<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title i18n=":@@blacklist-add-item.page-title">Adicionar</ion-title>

        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding padding-horizontal">

    <ion-grid>
        <ion-row>
            <ion-col>
                <form [formGroup]="Form">
                    <ion-item class="full" lines="full">
                        <ion-label position="stacked" i18n=":@@blacklist-add-item.keyword">Palavra
                        </ion-label>
                        <ion-input (keyup.enter)="OnAddAndVerify($event)" formControlName="Keyword"
                            type="text"></ion-input>
                    </ion-item>

                    <form-errors [control]="Form.get('Keyword')"></form-errors>
                </form>

            </ion-col>
            <ion-col size="2" sizeXl="6">
                <ion-button style="margin: 48px 16px 0;" (click)="OnAddAndVerify($event)">
                    <ion-icon slot="icon-only" name="add-outline"></ion-icon>
                </ion-button>
            </ion-col>
        </ion-row>
        <ion-row class="ion-margin-top">
            <ion-col>
                <ion-chip *ngFor="let item of NewKeywords" (click)="OnDeleteKeyword($event, item)">
                    <ion-label>{{item?.Name||'--'}}</ion-label>
                    <ion-icon name="close-circle"></ion-icon>
                </ion-chip>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>
<ion-footer>
    <ion-toolbar class="ion-padding-horizontal">
        <ion-button style="margin-right: -16px;" slot="end" fill="solid" color="medium"
            i18n=":@@modal_observation.submit" (click)="OnSave($event)">Guardar
        </ion-button>
    </ion-toolbar>
</ion-footer>